import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

const authHeaders = (accessToken) => ({ Authorization: `Bearer ${accessToken}` });

export const QUOTE_INTERVALS = [
    { value: 'day', label: 'Jour' },
    { value: 'week', label: 'Semaine' },
    { value: 'month', label: 'Mois' },
    { value: 'year', label: 'Année' },
];

export async function listQuotes(accessToken, status) {
    const res = await axios.get(`${API_URL}/api/quotes`, {
        headers: authHeaders(accessToken),
        params: status ? { status } : {},
    });
    return res.data.quotes || [];
}

export async function getQuote(accessToken, id) {
    const res = await axios.get(`${API_URL}/api/quotes/${id}`, { headers: authHeaders(accessToken) });
    return res.data.quote;
}

// Renvoie { quote, token, ephemeral_url } — c'est la SEULE réponse où le
// lien complet est exposé en clair, il doit être copié/transmis tout de
// suite : il ne sera plus jamais renvoyé par l'API ensuite.
export async function createQuote(accessToken, data) {
    const res = await axios.post(`${API_URL}/api/quotes`, data, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function revokeQuote(accessToken, id) {
    const res = await axios.post(`${API_URL}/api/quotes/${id}/revoke`, {}, { headers: authHeaders(accessToken) });
    return res.data.quote;
}

// Même remarque que createQuote : le nouveau lien n'est renvoyé qu'une fois.
export async function regenerateQuoteLink(accessToken, id) {
    const res = await axios.post(`${API_URL}/api/quotes/${id}/regenerate_link`, {}, { headers: authHeaders(accessToken) });
    return res.data;
}
